import { Button } from "@heroui/react";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import type { BridgeClaimParams, BridgeTxUnclaimedSuccess } from "../../state/types";

export function BridgeSuccessToast({
  onDismiss,
  unclaimedTxData,
  onClaim,
}: {
  onDismiss: () => void;
  unclaimedTxData: BridgeTxUnclaimedSuccess | null;
  onClaim: (claimData: BridgeClaimParams) => void;
}) {
  if (!unclaimedTxData) {
    return null;
  }

  return (
    <div className="flex gap-4 items-center turnstile-toast-border shadow-xl p-4 rounded-xl text-white fixed bottom-24 right-8 z-50">
      <BadgeCheckIcon className="size-10 stroke-1 text-green-500/90 fill-green-500/10 " />
      <div className="max-w-56">
        <div className="font-semibold">Transaction Completed!</div>
        <div className="text-[#AEC4D3] text-small">
          Claim your tokens on the Aztec Network. {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
          <span
            className="text-[#14DBC0] font-semibold cursor-pointer"
            onClick={() => {
              onClaim({
                ...unclaimedTxData,
                isManualClaim: false,
              });
            }}
          >
            Claim
          </span>
        </div>
      </div>
      <Button variant="light" isIconOnly onPress={onDismiss} className="text-white">
        <XIcon />
      </Button>
    </div>
  );
}
